/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiTestPushNotificationTestPost$Params {
    /**
     * Id dell'utente a cui inviare la notifica
     */
    utenteId: number;
}

export function apiTestPushNotificationTestPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiTestPushNotificationTestPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiTestPushNotificationTestPost.PATH, 'post');
    if (params) {
        rb.query('utenteId', params.utenteId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiTestPushNotificationTestPost.PATH = '/api/test/push-notification-test';
